import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Drawer, useMediaQuery, useTheme } from "@mui/material";
import DashboardSidebar from "./dashboard/DashboardSidebar";
import DashboardNavbar from "./dashboard/DashboardNavbar";

const drawerWidth = 280;

const DashboardLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      <DashboardNavbar onMenuClick={handleDrawerToggle} />
      <Box component="nav" sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}>
        {/* Mobile Drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderRight: "none",
            },
          }}
        >
          <DashboardSidebar onClose={handleDrawerToggle} />
        </Drawer>

        {/* Desktop Drawer */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderRight: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
              pt: "72px", // Space for Navbar
            },
          }}
          open
        >
          <DashboardSidebar onClose={handleDrawerToggle} />
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          pt: { xs: 10, md: 12 }, // Extra space for Navbar
          px: { xs: 2, md: 3.5 },
          pb: { xs: 4, md: 6 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 1440,
            mx: "auto",
            "& > .MuiPaper-root": {
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              boxShadow: "0 18px 40px rgba(15, 23, 42, 0.04)",
              overflow: "hidden",
              p: { xs: 2, md: 3 },
            },
            "& .MuiTableContainer-root": {
              borderRadius: 1.5,
              border: "1px solid",
              borderColor: "divider",
              overflowX: "auto", // Ensure tables are scrollable on mobile
            },
            "& .MuiTableHead-root .MuiTableCell-root": {
              bgcolor: "grey.50",
              color: "text.secondary",
              fontSize: 12,
              fontWeight: 700,
              textTransform: "uppercase",
              whiteSpace: "nowrap", // Keep headers on one line
            },
            "& .MuiTableCell-root": {
              px: { xs: 1.5, md: 2 },
            },
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
